// src/api/client.js
import axios from 'axios';

const client = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL, // ex) https://api.farmciti.com
  timeout: 10_000,                             // 10 sec
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor — e.g. adding tokens
client.interceptors.request.use(config => {
  const token = localStorage.getItem('ACCESS_TOKEN');
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response Interceptor — e.g. 401
client.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default client;
